<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import 'vant/lib/index.css';
export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
#app {
}
</style>
